<template>
	<div class="doctorPage managerPlan Manager">
		<div class="selectSearch" v-if="!splitScreen">
			<el-form ref="form" class="qcFrom searchConditions" :inline="true">
				<el-form-item label="关键词">
					<el-input v-model="scoreitemParameter.name" placeholder="名称" class="name" size="mini" v-if="isscreen.scheme"></el-input>
					<el-input v-model="scoreitemParameter.keyWord" placeholder="描述" class="name" size="mini" v-if="isscreen.rules"></el-input>
				</el-form-item>
				<!-- 评分方案搜索 -->
				<el-form-item label="适用类型" v-if="isscreen.scheme">
					<el-select v-model="scoreitemParameter.type" placeholder="请选择适用类型" size="mini" style="width:160px">
						<el-option label="全部" value="0"></el-option>
						<el-option v-for="item in detailsRulesParameter.schemeSearchType" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
					</el-select>
				</el-form-item>
				<!-- 评分细则搜索 -->
				<el-form-item label="适用类型" v-if="isscreen.rules">
					<el-select v-model="scoreitemParameter.type" placeholder="请选择适用类型" size="mini" style="width:160px">
						<el-option label="全部" value="0"></el-option>
						<el-option v-for="item in detailsRulesParameter.detailsRulesSearchType" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
					</el-select>
				</el-form-item>  
				<el-form-item label="错误类型" v-if="isscreen.rules">
					<el-select v-model="scoreitemParameter.specialType" placeholder="请选择错误类型" size="mini" style="width:160px">
						<el-option label="全部" :value="0"></el-option>
						<el-option label="普通" :value="2"></el-option>
						<el-option label="严重" :value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="状态">
					<el-select v-model="scoreitemParameter.enable" placeholder="请选择状态" size="mini" style="width:160px">
						<el-option label="全部" value="-1"></el-option>
						<el-option label="禁用" value="0"></el-option>
						<el-option label="启用" value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="设备">
					<el-select v-model="scoreitemParameter.modalityType" placeholder="请选择设备" size="mini" style="width:160px">
						<el-option label="全部" value="全部"></el-option>
						<el-option v-for="item in detailsRulesParameter.modalityType" :key="item.text" :label="item.text" :value="item.text"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="创建时间">
					<el-date-picker class="time mar4" v-model="pickerDate.date" type="daterange" @change="datePicker" size="mini"
					 range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间">
					</el-date-picker>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="search">查询</el-button>
				</el-form-item>
				<a href="javascript:;" class="addbtn" @click="showSchemeDetails" v-if="isscreen.scheme">新建评分方案</a>
				<a href="javascript:;" class="addbtn" @click="showDetails" v-if="isscreen.rules">新建评分细则</a>
			</el-form>
		</div>
		<!-- 中间内容 -->
		<div class="centerHome" :class="splitScreen?'centerHomeActive':''">
			<div class="closeSplitScreen el-icon-circle-close" v-if="splitScreen" @click="closeSplitScreen"></div>
			<div class="ccHomel" v-if="!splitScreen">

				<div class="compentTable">
					<div v-if="routers.indexOf('plan')>-1">
						<div v-if="routers.indexOf('scheme')>-1">
							<plan-scheme-table />
						</div>
						<div v-if="routers.indexOf('rules')>-1">
							<plan-rules-table />
						</div>
					</div>
					<div class="pages">
						<el-pagination class="pageAll" layout="prev, pager, next" :total="total" :page-size='scoreitemParameter.pageCount'
						 :current-page='scoreitemParameter.pageIndex' @current-change='currentChange'>
						</el-pagination>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// import { mapState, mapActions, mapMutations} from 'vuex'
	import planSchemeTable from '../../../components/plan/planSchemeTable.vue'
	import planRulesTable from '../../../components/plan/planRulesTable.vue'
	export default {
		data() {
			return {
				setDate: '',
				routers: '',
			}
		},
		components: {
			planSchemeTable,
			planRulesTable,
		},
		watch: {
			$route(to, from) {
				this.setRouter(to.path);
				this.routers = to.path;
			}
		},
		computed: {
			...Vuex.mapState('managerPlan', ['detailsRulesParameter','list', 'total', 'scoreitemParameter', 'globleDate', 'splitScreen', 'isscreen',
				'pickerDate'
			])
		},
		mounted() {
			this.$nextTick(function() {
				this.routers = this.$route.path;
				this.setRouter(this.$route.path)
				this.GetReportModality()
			})
		},
		methods: {
			...Vuex.mapMutations('managerPlan', ['currentChanges', 'setSearch', 'setDatePicker', 'setIsscreen', 'clearInit',
				'setSplitScreen', 'clearRulesFrom', 'clearQCPlan', 'setLoading'
			]),
			...Vuex.mapActions('managerPlan', ['scoreitem', 'qcplan','GetReportModality']),
			//设置路由
			setRouter(to) {
				if (to.indexOf('plan') > -1) {
					if (to.indexOf('scheme') > -1) {
						this.setIsscreen('scheme')
						this.qcplan()
					}
					if (to.indexOf('rules') > -1) {
						this.setIsscreen('rules')
						this.scoreitem()
					}
				}
			},
			//分页
			currentChange(val) {
				this.currentChanges(val)
				this.setRouter(this.routers)
				document.body.scrollTop = document.documentElement.scrollTop = 0;
			},
			//搜索
			search() {
				this.currentChanges(1)
				if (this.routers.indexOf('scheme') > -1) {
					this.qcplan()
				}
				if (this.routers.indexOf('rules') > -1) {
					this.scoreitem()
				}
				// this.setRouter(this.routers)
				document.body.scrollTop = document.documentElement.scrollTop = 0;
			},
			//创建日期
			datePicker(event) {
				this.setDatePicker(event)
			},
			//关闭分屏
			closeSplitScreen() {
				this.setLoading(false);
				this.setSplitScreen(false)
			},
			//评分细则显示详情
			showDetails() {
				//this.setSplitScreen(true)
				this.clearRulesFrom()
				this.$router.push("/home/plan/newRulesDetailsadd");
			},
			//评分方案新建
			showSchemeDetails() {
				this.clearQCPlan();
				this.$router.push("/home/plan/newSchemeDetailsadd");
			},
		}
	}
</script>
